import {
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";
import RemarkList from "../../components/remarkList";
import FileList from "../../components/fileList";
import ActivityLog from "../../components/activityLog";
import ProjectSummaryCard from "../../components/projectSummaryCard";
import QuotationProjectDetail from "../../components/quotationProjectDetail";
import QuotationChargeItem from "../../components/quotationChargeItem";
import QuotationCostItem from "../../components/quotationCostItem";
import Terms from "../../components/terms";
import { DateInput } from "@mantine/dates";
import remoteSelect2 from "../../components/remoteSelect2";
import { InputWrapper, TextInput, Textarea, Text, Box } from "@mantine/core";
import AutoCodeInput from "../../components/autoCodeInput";
import QuotationProjectSection from "../../components/quotationProjectSection";
import QuotationActionList from "../../components/quotationActionList";
import DummyWidget from "../../components/dummyWidget";
import { useCellRender } from "../../hooks/useCellRender";

const initialValues = {
  terms: [{ title: "", detail: "" }],
};
const apiEntity = "quotation";

export const QuotationAddForm = {
  name: "addSchema",
  title: "New Quotation",
  description: "Please follow the step to create a New Quotation",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: "1000px", //xs, sm, xl  ....100%
  },

  apiEntity,
  initialValues,

  layout: {
    containers: [],
    fields: [],
  },
};

export const QuotationEditForm = {
  name: "editSchema",
  title: "Edit Quotation",
  titleField: "code",
  description: "Please follow the step to create a New Quotation",
  display: {
    mode: ENUM_FORM_DISPLAY.LINK,
  },

  apiEntity,
  initialValues,

  layout: {
    containers: [
      {
        key: "main-g",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
        cols: [
          {
            key: "main-g1",
            props: {
              span: 3,
            },
          },
          {
            key: "main-g2",
            props: {
              span: 9,
            },
          },
        ],
      },
      {
        key: "main-tab",
        parent: "main-g2",
        type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
        props: {
          variant: "default", //default | pills | outline
          defaultValue: "Overview",
        },
        tab: [
          {
            key: "tab-overview",
            label: "Overview",
          },
          {
            key: "tab-file",
            label: "Files",
          },
          {
            key: "tab-log",
            label: "Logs",
          },
        ],
      },

      {
        key: "section-quotation-basic",
        parent: "tab-overview",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Baisc Information",
          // titleOrder: 5,
          // description: "Please assign the corresponding consultant",
          withBorder: false,
          minHeight: "0px",
          mt: 0,
          mb: 20,
        },
      },
      {
        key: "section-project-info",
        parent: "tab-overview",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Project Information",
          // titleOrder: 5,
          // description: "Please assign the corresponding consultant",
          withBorder: false,
          minHeight: "0px",
          mt: 0,
          mb: 20,
        },
      },
      {
        key: "section-client-info",
        parent: "tab-overview",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Client Information",
          // titleOrder: 5,
          // description: "Please assign the corresponding consultant",
          withBorder: false,
          minHeight: "0px",
          mt: 0,
          mb: 20,
        },
      },

      {
        key: "section-detail",
        parent: "tab-overview",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Details",
          // titleOrder: 5,
          // description: "Please assign the corresponding consultant",
          withBorder: false,
          minHeight: "0px",
          mt: 0,
          mb: 20,
        },
      },

      {
        key: "detail-tab",
        parent: "section-detail",
        type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
        props: {
          variant: "default", //default | pills | outline
          defaultValue: "Charge Items",
        },
        tab: [
          {
            key: "tab-charge",
            label: "Charge Items",
          },
          {
            key: "tab-cost",
            label: "Cost Items",
          },
        ],
      },

      {
        key: "detail-tab",
        parent: "section-quotation-basic",
        type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
        cols: [
          {
            key: "basic-g1",
            props: {
              span: 4,
            },
          },
          {
            key: "basic-g2",
            props: {
              span: 4,
            },
          },
          {
            key: "basic-g3",
            props: {
              span: 4,
            },
          },
        ],
      },
      {
        key: "client-tab",
        parent: "section-client-info",
        type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
        cols: [
          {
            key: "client-g1",
            props: {
              span: 6,
            },
          },
          {
            key: "client-g2",
            props: {
              span: 6,
            },
          },
        ],
      },
      {
        key: "section-term",
        parent: "tab-overview",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Terms",
          // titleOrder: 5,
          // description: "Please assign the corresponding consultant",
          withBorder: false,
          minHeight: "0px",
          mt: 0,
          mb: 20,
        },
      },
      {
        key: "section-remarks",
        parent: "tab-overview",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Remarks",
          // titleOrder: 5,
          // description: "Please assign the corresponding consultant",
          withBorder: false,
          minHeight: "0px",
          mt: 0,
          mb: 20,
        },
      },
      {
        key: "section-file",
        parent: "tab-file",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Files",
          // titleOrder: 5,
          // description: "Please assign the corresponding consultant",
          withBorder: false,
          minHeight: "0px",
          mt: 0,
          mb: 20,
        },
      },
      {
        key: "section-log",
        parent: "tab-log",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Logs",
          // titleOrder: 5,
          // description: "Please assign the corresponding consultant",
          withBorder: false,
          minHeight: "0px",
          mt: 0,
          mb: 20,
        },
      },
    ],
    fields: [
      {
        name: "project",
        component: QuotationProjectDetail,
        parent: "main-g1",
        props: {
          title: "Project Details",
        },
      },
      {
        name: "code",
        component: AutoCodeInput,
        parent: "basic-g2",
        props: {
          label: "Quo No.",
        },
      },
      {
        name: "status",
        component: DummyWidget,
        parent: "basic-g3",
        props: {
          dummyRender: (data, cellRender) => {
            return (
              <InputWrapper label="Status">
                <Box>{cellRender.Quotation.status(data?.status)}</Box>
              </InputWrapper>
            );
          },
        },
      },
      {
        name: "quoDate",
        component: DateInput,
        parent: "basic-g1",
        type: "dateInput",
        props: {
          label: "Quo Date",
          zIndex: 1000,
          placeholder: "Pick Date",
          allowFreeInput: true,
          defaultValue: new Date(),
        },
      },
      {
        name: "client",
        component: remoteSelect2,
        parent: "client-g1",
        props: {
          label: "Client",
          apiEntity: "client",
          valueField: "_id",
          labelField: "name",
          searchFields: ["name", "cname", "code"],
          sort: {
            by: "name",
            order: "desc",
          },
        },
      },
      {
        name: "attn",
        component: TextInput,
        parent: "client-g2",
        props: {
          label: "Attn",
        },
      },
      {
        name: "tel",
        component: TextInput,
        parent: "client-g1",
        props: {
          label: "Tel",
        },
      },
      {
        name: "email",
        component: TextInput,
        parent: "client-g2",
        props: {
          label: "Email",
        },
      },
      {
        name: "fax",
        component: TextInput,
        parent: "client-g1",
        props: {
          label: "Fax",
        },
      },
      {
        name: "address",
        component: Textarea,
        parent: "client-g2",
        props: {
          label: "Address",
          autosize: true,
          minRows: 1,
        },
      },

      {
        name: "project",
        component: QuotationProjectSection,
        parent: "section-project-info",
        props: {},
      },
      {
        name: "chargeItems",
        component: QuotationChargeItem,
        parent: "tab-charge",
        props: {},
      },

      {
        name: "costItems",
        component: QuotationCostItem,
        parent: "tab-cost",
        props: {},
      },

      {
        name: "terms",
        component: Terms,
        parent: "section-term",
        props: {
          templateCategory: "quotationTerms",
        },
      },
      {
        name: "remarks",
        component: RemarkList,
        parent: "section-remarks",
      },

      {
        name: "files",
        component: FileList,
        parent: "section-file",
      },
      {
        name: "log",
        component: ActivityLog,
        parent: "section-log",
      },
      {
        name: "actions",
        component: QuotationActionList,
        parent: "main-g1",
        props: {},
      },
    ],
  },
};

export const QuotationFormSchema = {
  add: QuotationAddForm,
  edit: QuotationEditForm,
};
